const getInitialState = () => ({
	settings: {},
	options: {},
	visibleFields: [],
	generalErrors: [],
	fieldErrors: {}
});

export default getInitialState;
